/** @format */

export const DEFAULT_TEST_ID = 'product-comparison-display';
export const DEFAULT_ROW_COUNT = 8;
